<template>
  <b-table :items="items" :fields="fields" thead-class="hidden_header">
    <template #cell(quantity)="row">
      {{ format(row.item.quantity) }}
    </template>
    <template #cell(price)="row"> R$ {{ format(row.item.price) }} </template>
    <template #cell(discount)="row">
      {{ format(row.item.discount) }}
    </template>
    <template #cell(totalPrice)="row">
      R$ {{ format(row.item.totalPrice) }}
    </template>
    <template #cell(actions)="row">
      <div class="text-center text-muted">
        <span role="button">
          <b-row no-gutters>
            <b-col @click="editRow(row)">
              <Edit v-if="!disabled" class="icon-2x" title="Editar" />
            </b-col>
            <b-col @click="removeRow(row)">
              <Close v-if="!disabled" class="icon-2x" title="Cancelar" />
            </b-col>
          </b-row>
        </span>
      </div>
    </template>
  </b-table>
</template>

<script>
import Edit from 'vue-material-design-icons/Pencil';
import Close from 'vue-material-design-icons/Close';
import FormatMixin from '../../../../../../Application/mixins/FormatMixin';

export default {
  name: 'ServiceList',
  mixins: [FormatMixin],
  components: { Edit, Close },
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    fields: [],
    items: [],
  },
  methods: {
    format(value) {
      return typeof value === 'number' ? this.roundAndFormat(value, 2) : value;
    },
    editRow(data) {
      this.$emit('edit', data);
    },
    removeRow(data) {
      this.$emit('remove', data);
    },
  },
};
</script>

<style>
.hidden_header {
  display: none;
}
</style>
